// extracted by mini-css-extract-plugin
export default {"wrapper":"ServiceProvider_wrapper__HhUrG","details":"ServiceProvider_details__GVme-","details__item":"ServiceProvider_details__item__6DbtR"};